import { ForwardedRef, PropsWithChildren, forwardRef } from 'react';
import { Pattern, SwatchBorderStyle } from '@common/api';
import { ColorBadgeOuter, ColorBadgeInner } from './Color.style';

export type ColorBadgeProps = PropsWithChildren<{
    disabled?: boolean;
    color?: string | null;
    border?: string | null;
    pattern?: Pattern;
    borderStyle?: SwatchBorderStyle;
    selected?: boolean;
    round?: boolean;
    button?: boolean;

    onClick?: () => void;
}>;

export const ColorBadge = forwardRef((props: ColorBadgeProps, ref: ForwardedRef<HTMLDivElement>) => {
    const { color, border, borderStyle, pattern, selected, disabled, round, onClick, children } = props;

    return (
        <ColorBadgeOuter ref={ref} $disabled={disabled} $selected={selected} $round={round} onClick={onClick}>
            {children ?? (
                <ColorBadgeInner
                    $color={color}
                    $border={border}
                    $borderStyle={borderStyle}
                    $pattern={pattern}
                    $round={round}
                />
            )}
        </ColorBadgeOuter>
    );
});

ColorBadge.displayName = 'ColorBadge';
